import React, { useEffect, useState, useLayoutEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { Collapse, Button, Spin, notification, Modal } from "antd";
import Slider from "react-slick";
import { CaretRightOutlined } from "@ant-design/icons";
import { useInjectReducer, useInjectSaga } from "redux-injectors";
import { sliceKey, reducer, actions } from "./slice";
import { placeOrderSaga } from "./saga";
import * as selectors from "./selectors";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import TestCard from "../../../../components/TestCard";
import PageTitle from "../../../../components/PageTitle";
import CreatePackageForm from "../../../../forms/CreatePackageForm";
import { useAuth } from "../../../../contexts/auth";
import "./style.css";

const { Panel } = Collapse;

const schema = yup.object().shape({
  commodity: yup.string().required().label("Commodity"),
  name: yup
    .string()
    .required()
    .matches(/^(?!\s+$).+/, "Please provide valid values for name")
    .label("Package Name"),
  tests: yup.array().min(1).of(yup.string()).required().label("Parameter"),
});

const PlaceOrder = () => {
  useInjectReducer({ key: sliceKey, reducer: reducer });
  useInjectSaga({ key: sliceKey, saga: placeOrderSaga });
  const dispatch = useDispatch();
  const auth = useAuth();
  const user = auth.loggedInUser;
  const companyId = user.company._id;

  const {
    control,
    handleSubmit,
    reset,
    formState: { errors },
    setValue,
    watch,
  } = useForm({
    defaultValues: {
      name: "",
      tests: [],
      commodity: "",
    },
    resolver: yupResolver(schema),
  });

  const [packageTabModalVisible, setPackageTabModalVisible] = useState(false);
  const [reload, setReload] = useState(false);

  useEffect(() => {
    //
    if (companyId) {
      dispatch(actions.fetchPackages());
      dispatch(actions.fetchCommodities({ companyId: companyId }));
      //dispatch(actions.fetchCompanyCatalog());
    }
    return () => {
      dispatch(actions.initializeState());
    };
  }, [dispatch, reload, companyId]);

  // const categories = useSelector(selectors.selectCategories);
  const recommendedPackages = useSelector(selectors.selectPackages);
  const fetchingCatalog = useSelector(selectors.selectFetchingCatalog);
  const fetchingPackages = useSelector(selectors.selectFetchingPackages);
  const commodities = useSelector(selectors.selectCommodities);
  const tests = useSelector(selectors.selectTests);
  const error = useSelector(selectors.selectError);

  const selectedCommodity = watch("commodity");

  useEffect(() => {
    if (error && error !== "") {
      notification.error({
        message: "Error Adding Package",
        description: error,
      });
      setTimeout(() => {
        dispatch(actions.initializeError());
      }, 1500);
    }
  }, [error, dispatch]);

  useEffect(() => {
    if (selectedCommodity) {
      dispatch(
        actions.fetchTests({
          companyId: companyId,
          commodityId: selectedCommodity,
        })
      );
    }
  }, [dispatch, selectedCommodity, companyId]);

  const handleSuccess = () => {
    reset();
    setPackageTabModalVisible(false);
    setReload(!reload);
    notification.success({
      message: "Success!",
      description: "Your package is created",
      onClick: () => {
        console.log("Clicked!");
      },
    });
  };

  const handleFailure = () => {
    console.log("An error occured");
  };
  const handleCreatePackage = (data) => {
    const payloadData = {
      name: data.name,
      tests: data.tests,
    };
    const payload = {
      onSuccess: handleSuccess,
      data: payloadData,
      onFailure: handleFailure,
    };
    console.log(payload);
    //setPackageTabModalVisible(false);

    dispatch(actions.createPackage(payload));
  };

  const handleDispatchRequestForTests = (commodity) => {
    if (commodity) {
      dispatch(
        actions.fetchTests({ companyId: companyId, commodityId: commodity })
      );
    }
  };

  const renderCommodities = (entries, windowSize) => {
    const rows = [];
    entries.forEach((entry, index) => {
      rows.push(
        <Panel
          header={
            <span style={{ fontWeight: "bold", color: "#0a8080" }}>
              {entry.label}
            </span>
          }
          key={index}
          style={{
            marginBottom: 20,
            overflow: "auto",
            backgroundColor: "#eff3f7",
            border: "0px",
            borderRadius: 4,
            color: "#0a8080",
          }}
          id="panelHeader"
        >
          <div style={{ display: "flex" }}>
            {entry.options.map((commodity) => {
              if (commodity) {
                return (
                  <div style={{ marginRight: 20 }} key={commodity.value}>
                    <Link to={`/booking?commodityId=${commodity.value}`}>
                      <Button
                        type="primary"
                        size={
                          windowSize > 600
                            ? "large"
                            : windowSize > 500
                            ? "middle"
                            : "small"
                        }
                      >
                        {commodity.label}
                      </Button>
                    </Link>
                  </div>
                );
              }
              return "";
            })}
          </div>
        </Panel>
      );
    });
    return rows;
  };

  const handleCancel = () => {
    reset();
    setPackageTabModalVisible(false);
  };
  const getTestCategories = () => {
    setValue("tests", []);
    /* const testCategories = [];
    const selectedCategories = [];
    catalog.forEach((item) => {
      const test = item.test;
      const testCategory = test.testCategory;
      const commodity = test.commodity;
      if (commodity._id === selectedCommodity) {
        const selectedCatIndex = selectedCategories.indexOf(testCategory._id);
        if (selectedCatIndex === -1) {
          selectedCategories.push(testCategory._id);
          testCategories.push({
            title: testCategory.name,
            key: testCategory._id,
            value: testCategory._id,
            children: [
              {
                title: (
                  <div
                    style={{ display: "flex", justifyContent: "space-between" }}
                  >
                    <p>{test.parameter}</p>
                    <p>₹{item.price}</p>
                  </div>
                ),
                key: test._id,
                value: item._id,
              },
            ],
          });
        } else {
          // add test to children
          const testIndex = testCategories[selectedCatIndex].children.findIndex(
            (item) => item.key === test._id
          );
          if (testIndex === -1) {
            testCategories[selectedCatIndex].children.push({
              title: (
                <div
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <p>{test.parameter}</p>
                  <p>₹{item.price}</p>
                </div>
              ),
              key: test._id,
              value: item._id,
            });
          }
        }
      }
    });
    return testCategories; */
    if (tests.length) {
      const testCategories = [];

      tests.forEach((test) => {
        const children = test.options.map((child) => {
          let obj = {
            title: (
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <p>{child.label}</p>
                <p>₹{child.price}</p>
              </div>
            ),
            key: child.value,
            value: child.value,
          };

          return obj;
        });
        testCategories.push({
          title: test.label,
          key: test.value,
          value: test.value,
          children: children,
        });
      });

      return testCategories;
    }
  };

  const [windowSize, setWindowSize] = useState(window.innerWidth);
  const width = window.innerWidth - 100;
  //let slidesToShow = Math.floor(width / 270);

  let slidesToShow = 0;
  if (width > 270) {
    if (recommendedPackages.length < Math.floor(width / 270)) {
      slidesToShow = recommendedPackages.length;
    } else {
      slidesToShow = Math.floor(width / 270);
    }
  } else {
    slidesToShow = 1;
  }

  useLayoutEffect(() => {
    function updateWindowSize() {
      setWindowSize(window.innerWidth);
    }
    window.addEventListener("resize", updateWindowSize);
    updateWindowSize();
    return () => window.removeEventListener("resize", updateWindowSize);
  }, []);

  return (
    <div>
      {
        <div style={{ float: "right" }}>
          <Button
            size={
              windowSize > 600 ? "large" : windowSize > 500 ? "middle" : "small"
            }
            type="primary"
            onClick={() => {
              setPackageTabModalVisible(true);
            }}
          >
            Create Package
          </Button>
        </div>
      }

      {recommendedPackages?.length ? (
        <div>
          <PageTitle title="Recommended Packages" />
          {fetchingPackages ? (
            <div
              style={{
                width: "100vw",
                height: "320px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Spin size="large" />
            </div>
          ) : (
            <Slider
              arrows
              dots
              variableWidth
              infinite={true}
              /*slidesToShow={
                recommendedPackages.length < slidesToShow
                  ? recommendedPackages.length
                  : slidesToShow
              }*/
              slidesToShow={slidesToShow}
              slidesToScroll={1}
            >
              {recommendedPackages.map((recPackage) => (
                <TestCard data={recPackage} />
              ))}
            </Slider>
          )}
        </div>
      ) : (
        ""
      )}
      <div style={{ marginTop: 40 }}>
        <PageTitle title="Book a Test" />
        {fetchingCatalog ? (
          <div className="bookTestSection">
            <Spin size="large" />
          </div>
        ) : (
          <Collapse
            bordered={false}
            expandIconPosition="right"
            expandIcon={({ isActive }) => (
              <CaretRightOutlined
                style={{ color: "#0a8080" }}
                rotate={isActive ? 90 : 0}
              />
            )}
            style={{ background: "#fff" }}
          >
            {renderCommodities(commodities, windowSize)}
          </Collapse>
        )}
      </div>
      <Modal
        title="Create A Package"
        visible={packageTabModalVisible}
        okText="Submit"
        onOk={handleSubmit(handleCreatePackage)}
        onCancel={handleCancel}
      >
        <CreatePackageForm
          setVisible={setPackageTabModalVisible}
          onSave={handleCreatePackage}
          getTestCategories={getTestCategories}
          commodities={commodities}
          control={control}
          errors={errors}
          tests={tests}
          handleDispatch={handleDispatchRequestForTests}
        />
      </Modal>
    </div>
  );
};

export default PlaceOrder;
